var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94531 8.08164C8.94531 7.84295 9.04013 7.61403 9.20892 7.44524C9.3777 7.27646 9.60662 7.18164 9.84531 7.18164C10.084 7.18164 10.3129 7.27646 10.4817 7.44524C10.6505 7.61403 10.7453 7.84295 10.7453 8.08164V13.4816C10.7453 13.7203 10.6505 13.9493 10.4817 14.118C10.3129 14.2868 10.084 14.3816 9.84531 14.3816C9.60662 14.3816 9.3777 14.2868 9.20892 14.118C9.04013 13.9493 8.94531 13.7203 8.94531 13.4816V8.08164Z",
    fill: "#B54708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84531 3.64648C9.60662 3.64648 9.3777 3.74131 9.20892 3.91009C9.04013 4.07887 8.94531 4.30779 8.94531 4.54648C8.94531 4.78518 9.04013 5.0141 9.20892 5.18288C9.3777 5.35166 9.60662 5.44648 9.84531 5.44648C10.084 5.44648 10.3129 5.35166 10.4817 5.18288C10.6505 5.0141 10.7453 4.78518 10.7453 4.54648C10.7453 4.30779 10.6505 4.07887 10.4817 3.91009C10.3129 3.74131 10.084 3.64648 9.84531 3.64648Z",
    fill: "#B54708"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8457 0C4.875 0 0.845703 4.0293 0.845703 9C0.845703 13.9707 4.875 18 9.8457 18C14.8164 18 18.8457 13.9707 18.8457 9C18.8457 4.0293 14.8164 0 9.8457 0ZM2.6457 9C2.6457 10.9096 3.40427 12.7409 4.75453 14.0912C6.1048 15.4414 7.93614 16.2 9.8457 16.2C11.7553 16.2 13.5866 15.4414 14.9369 14.0912C16.2871 12.7409 17.0457 10.9096 17.0457 9C17.0457 7.09044 16.2871 5.25909 14.9369 3.90883C13.5866 2.55857 11.7553 1.8 9.8457 1.8C7.93614 1.8 6.1048 2.55857 4.75453 3.90883C3.40427 5.25909 2.6457 7.09044 2.6457 9Z",
    fill: "#B54708"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a6c04700f9638cc363a6381c2b52f77e.svg";
export { ForwardRef as ReactComponent };